import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ContractedFeaturesEnum } from '../models/enum/contracted-features.enum';
import { ContractedFeature } from '../models/interfaces/contracted-features.interface';
import { buildCookieServiceOptions } from './cookie.utils';

@Injectable({ providedIn: 'root' })
export class ContractedFeatureUtil {
  constructor(private cookieService: CookieService) { }

  addFeatures(features: ContractedFeature[]): void {
    const featuresJson = JSON.stringify(
      features.map((item) => {
        return item.name;
      })
    );
    this.cookieService.set('contracted-features', featuresJson, buildCookieServiceOptions(false));
  }

  hasCheguei(): boolean {
    return this.cookieService.get('contracted-features').includes(ContractedFeaturesEnum.CHEGUEI);
  }

  hasSeatBookings(): boolean {
    return this.cookieService.get('contracted-features').includes(ContractedFeaturesEnum.SEAT_BOOKINGS);
  }

  hasTicketsFeature(): boolean {
    return this.cookieService.get('contracted-features').includes(ContractedFeaturesEnum.TICKETS);
  }
}
